// extracted by mini-css-extract-plugin
module.exports = {"title":"related-articles_title__yBIj4","video-spin":"related-articles_video-spin__76pd_"};